import React from 'react';
import { Text, View } from 'react-native';
import { styles } from './styles';
import { _label } from 'apps/rails/src/vernacular/AppLanguage';

const rupee = '₹';

function ToolTip({
  paymentFareBreakup,
  basePrice,
  totalPrice,
  containerType,
  marginLeft,
}: {
  paymentFareBreakup: any;
  basePrice: number;
  totalPrice: number;
  containerType: number;
  marginLeft: number;
}) {
  const headerText = containerType === 1 ? _label('ticket_fare') : _label('partial_ticket_fare');

  return (
    <View style={containerType === 1 ? styles.toolTipContainer1 : styles.toolTipContainer2}>
      <View style={[styles.arrowTop, { marginLeft: marginLeft }]} />
      <View style={styles.toolTipInnerContainer}>
        <View style={styles.tooltipTextPartialTicketFare}>
          <Text style={[styles.toolTipTextTitles, { fontWeight: '700' }]}>
            {headerText}
          </Text>
          <Text
            style={[styles.toolTipPrice, { fontWeight: '700' }]}
          >{`${rupee} ${basePrice}`}</Text>
        </View>
        <View style={styles.tooltipText}>
          <Text style={styles.toolTipTextTitles}>{paymentFareBreakup[0]?.mainText}</Text>
          <Text style={styles.toolTipPrice}>{`${rupee} ${paymentFareBreakup[0]?.amount}`}</Text>
        </View>
        <View style={styles.tooltipText}>
          <Text style={styles.toolTipTextTitles}>{paymentFareBreakup[1]?.mainText}</Text>
          <Text style={styles.toolTipPrice}>{`${rupee} ${paymentFareBreakup[1]?.amount}`}</Text>
        </View>
        <View style={styles.bar} />
        <View style={styles.tooltipTextTotalPayable}>
          <Text style={styles.toolTipTotalPayable}>{_label('total_payable')}</Text>
          <Text
            style={[styles.toolTipPrice, { fontWeight: '700' }]}
          >{`${rupee} ${totalPrice}`}</Text>
        </View>
      </View>
    </View>
  );
}

export default ToolTip;
